export default __webpack_public_path__ + "static/media/HConnectLogo_colored_white_text.3a8198ed.svg";